import React, { useState } from "react";
//assets
import backmassage from "./curtmassage.webp";
import wellnesscontent from "./wellnesscontent";
import face from "../../assets/facial-treatment.png";
import target from "../../assets/target.png";
import massage from "../../assets/body-spa.png";

//gallery images
import mc1 from "./GalleryPhotos/mc1.webp";
import mc2 from "./GalleryPhotos/mc2.webp";
import mc3 from "./GalleryPhotos/mc3.webp";
import mc4 from "./GalleryPhotos/mc-4.webp";
import mc5 from "./GalleryPhotos/mc5.webp";
import mc6 from "./GalleryPhotos/mc6.webp";
import mc7 from "./GalleryPhotos/mc7.webp";
import mc8 from "./GalleryPhotos/mc8.webp";
import mc9 from "./GalleryPhotos/mc9.webp";
import mc10 from "./GalleryPhotos/mc10.webp";

//components
import CallButton from "../../components/DiscoveryButton/CallButton";
import IconContainer from "../../components/Icons/IconContainer";
import ImageGallery from "../PT/ImageGallery";
//libraries
import { Helmet } from "react-helmet-async";

//css
import "./../PT/ServicesScreen.scss";

const MassageScreen = () => {
  const imageGallery = [mc1, mc2, mc3, mc4, mc5, mc6, mc7, mc8, mc9, mc10];
  const [icons] = useState([
    { icon: massage, alt: "hands massaging back icon" },
    { icon: target, alt: "target icon" },
    { icon: face, alt: "face massage icon" },
  ]);
  return (
    <>
      <Helmet>
        <title>Massage Therapy | Concierge Wellness Colorado Springs</title>

        <meta
          name="description"
          content="Sports-focused massage therapy in Colorado Springs designed to improve mobility, reduce muscle tension, accelerate recovery, and help active individuals perform at their best."
        />

        <link
          rel="canonical"
          href="https://conciergewellnesspt.com/massagetherapy"
        />

        <meta
          property="og:title"
          content="Massage Therapy | Concierge Wellness"
        />

        <meta
          property="og:description"
          content="Move better, recover faster, and stay active with personalized massage therapy services in Colorado Springs."
        />

        <meta
          property="og:url"
          content="https://conciergewellnesspt.com/massagetherapy"
        />

        <meta property="og:type" content="website" />

        <meta
          property="og:image"
          content="https://conciergewellnesspt.com/icon.png"
        />
      </Helmet>
      <main className="services">
        <div
          className="services-container"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          {/* image and blue underneath...commented out is template for two images */}
          <div className="image-container">
            {/* <img
              className="main-photo two-images"
              src={backmassage}
              alt="hands massaging a back"
              title="Photo by Olia Danilevich"
            />{" "}
            <img
              className="main-photo two-images second-image"
              src={jeremy}
              title="Photo by Jeremy Thomas on Unsplash"
              alt="A rock cairn"
            /> */}
            <img
              className="main-photo"
              src={backmassage}
              alt="Massage therapist applies pressure with his elbow to a patient's back"
            />
            <div className="blue-overlapping"></div>
          </div>

          {/* text of services screen */}
          <div className="services-main">
            <div className="services-background">
              <div className="services-text">
                <h1>{wellnesscontent.header}</h1>
                <h4>{wellnesscontent.subheading}</h4>

                <span className="hr-line"></span>

                {/* image placement for small screens */}
                <div className="small-screen-image-container">
                  <img
                    className="small-screen-photo"
                    src={backmassage}
                    alt="Dr. Wade helps a patient achieve proper form with a kettlebell exercise"
                  />
                </div>
                <p>{wellnesscontent.summary}</p>
                <div className="service-list">
                  <ul>
                    {wellnesscontent.listOne.map((service) => (
                      <li key={service}>{service}</li>
                    ))}
                  </ul>
                </div>
              </div>

              <span className="hr-line"></span>

              {/* three icons at the bottom of services text */}
              <div className="services-icons">
                {icons.map((icon) => (
                  <IconContainer
                    icon={icon.icon}
                    key={icon.alt}
                    alt={icon.alt}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </main>

      <ImageGallery images={imageGallery} />
      <div className="call-button-container">
        <CallButton />
      </div>
    </>
  );
};

export default MassageScreen;
